import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { store } from "../store";
import i18next from "i18next";

export const getStoreOrdersRequest = () => ({
  type: "GET_STORE_ORDERS_REQUEST",
});

export const getStoreOrdersSuccess = (orders) => ({
  type: "GET_STORE_ORDERS_SUCCESS",
  payload: orders,
});

export const getStoreOrdersFailure = (error) => ({
  type: "GET_STORE_ORDERS_FAILURE",
  payload: error,
});

// export const fetchStoreOrders = (pagination, searchTerm, order_filter, prodName) => async (dispatch) => {
  export const fetchStoreOrders = (pagination, searchTerm = "", order_filter = "", prodName = "", orderFromId, type) => async (dispatch) => {
  // console.log("PPPPPPPPP", order_filter);
  
  const { login } = store.getState();
  // const urlParams = new URLSearchParams(window.location.search);
  // const isRefundOrder = urlParams.get("refundorder") !== null;
  const forRefund = store.getState().refundReducer.forRefund;  // Get from Redux
  const lang = i18next.language



  dispatch(getStoreOrdersRequest());

  try {
    const payload = {
      company_id: login?.user?.result?.company_id,
      lang: lang,
      offset: pagination,
      limit: 20,
      order_ref: searchTerm,
      product_name: type === 'product' ? prodName : '',
      order_type: "",
      order_filter: order_filter || "",
      order_from_id : orderFromId,
      "product_custom_name": type === 'customName' ? prodName : '',
    "product_shortcut": type === 'shortCode' ? prodName : ''
    };

    if (forRefund) {
      payload.company_id = login?.user?.result?.company_id;
    } else {
      payload.user_id = login?.user?.result?.user_id;
    }

    const response = await axiosInstance.post(URLS.POS_ORDERS, payload);
    // console.log("orders response", response)
    if (response?.data.result.records) {
      dispatch(getStoreOrdersSuccess(response?.data?.result?.records));
    } else {
      dispatch(getStoreOrdersFailure("Failed to fetch orders"));
    }
  } catch (error) {
    dispatch(getStoreOrdersFailure(error.message));
  }
};